/**
 * Vendor program header block for commissions
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Divider, Grid, Typography } from '@mui/material';
import RcpView from './RcpView';
import RcpCommView from './RcpCommView';

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  }
});

/*
<VendorPartnerProgramBlockCommission vpp={this.props.vpp} vppBlock={content} vppRelationship={this.props.relationship}/>
*/
class VendorPartnerProgramBlockCommission extends Component {

  render() {
    let vpp = this.props.vpp;
    let vr = this.props.vppRelationship; // This will have one or more reseller program ids - but we'll need to derive them.

    let relevantPIds = [];

    if (vr.accountTByPartnerId != null && vr.accountTByPartnerId.resellerProgramTsByResellerAccountId.totalCount > 0) {
      let nodes = vr.accountTByPartnerId.resellerProgramTsByResellerAccountId.nodes;
      for (let i=0; i<nodes.length; i++) {
        let n = nodes[i];
        if (n.cpTByCpId.accountId === vpp.vendorId) {
          relevantPIds.push(n.resellerPId);
        }
      }
    }
    
    if (relevantPIds.length > 0) {
      if (relevantPIds.length > 1) {
        return (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Your commissions</Typography>
            </Grid>
            { relevantPIds.map(pId => {
              return (
                <React.Fragment key={pId}>
                  <Grid item xs={12}>
                    <Divider/>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2} alignItems="flex-end" justifyContent="space-between">
                      <Grid item  xs={12} md={6} lg={8} xl={9}>
                        <RcpView nameInHeading={true} resellerPId={pId} auth={this.props.auth}/>
                      </Grid>
                      <Grid item  xs={12} md={6} lg={4} xl={3}>
                        <RcpCommView resellerPId={pId} auth={this.props.auth}/>
                      </Grid>
                    </Grid>
                  </Grid>
                </React.Fragment>
              );
            })}
          </Grid>
        );
      } else {
        return (
          /* 
          <Grid container rowSpacing={2} columnSpacing={3} alignItems="flex-end">
            <Grid item xs={12}>
              <Typography variant="h6">Your commissions</Typography>
            </Grid>
            <Grid item style={{maxWidth: "300px"}}>
              <RcpView nameInHeading={false} resellerPId={relevantPIds[0]} auth={this.props.auth}/>
            </Grid>
            <Grid item>
              <RcpCommView resellerPId={relevantPIds[0]} auth={this.props.auth}/>
            </Grid>
          </Grid>
          */
          <Grid container direction="row" rowSpacing={2} columnSpacing={3} alignItems="flex-end" justifyContent="space-between">
            <Grid item xs={12}>
              <Typography variant="h6">Your commissions</Typography>
            </Grid>
            <Grid item xs={12} lg={7} xl={9}>
              <RcpView nameInHeading={false} resellerPId={relevantPIds[0]} auth={this.props.auth}/>
            </Grid>
            <Grid item xs={12} lg={5} xl={3}>
              <RcpCommView resellerPId={relevantPIds[0]} auth={this.props.auth}/>
            </Grid>
          </Grid>
        );
      }
    }
    
    return (
      <Grid container spacing={2} direction="column" justifyContent="flex-start">
        <Grid item>
          <Typography variant="h6">Your commissions</Typography>
        </Grid>
        {this.props.devMode === false &&
        <Grid item>
          <Typography variant="body2">You aren't signed up for a commission program.</Typography>
        </Grid>}
        {this.props.devMode === true &&
        <Grid item>
          <Typography variant="body2">In dev mode when there is no partner selected, commissions program(s) cannot be shown.</Typography>
        </Grid>}
      </Grid>
    );
  }
}
  
export default withStyles(styleSheet)(VendorPartnerProgramBlockCommission);